const activeExperiments = ['Personalise Black Friday', 'Homepage intro black friday']

export { activeExperiments }
